import React, {useEffect, useState} from "react";
import Aux from "../../../../hoc/Auxiliary/Auxiliary";
import {Col, Row} from "react-bootstrap";
import Icon from "../../../UI/Icon/Icon";
import {cloneDeep} from "lodash";
import LinguisticSkillEntity from "./LinguisticSkill/LinguisticSkillEntity";
import classes from "./LinguisticSkill/LinguisticSkill.module.css";
import {translation} from "../../../../I18n/i18n";
import EditCard from "../../../UI/SkillCard/EditCard";
import ConsultCard from "../../../UI/SkillCard/ConsultCard";
import FormLinguisticSkill from "./LinguisticSkill/EditLinguisticSkill";

const LinguisticSkills = (props) => {
    const [expanded, setExpanded] = useState(false);
    const [editElement, setEditElement] = useState();
    const [previousLinguisticSkills, setPreviousLinguisticSkills] = useState([]);
    const [removedElements, setRemovedElements] = useState([]);

    const [languageList, setLanguageList] = useState([]);
    useEffect(() => updateLanguageList(), [])

    const addLinguisticSkillHandler = () => {
        const newEmptyLinguisticSkill = cloneDeep(LinguisticSkillEntity);
        setPreviousLinguisticSkills(previousLinguisticSkills.concat(newEmptyLinguisticSkill));
        setExpanded(true);
    };

    const cancelEditLinguisticSkillHandler = () => {
        setEditElement(null)
    };

    const submitHandler = () => {
        if (props.element) {
            props.element.push(previousLinguisticSkills[previousLinguisticSkills.length - 1]);
            setExpanded(false);
            updateLanguageList()
        }
    };

    const submitEditHandler = (element) => {
        props.element.map((e, i) => {
            if (e === editElement) {
                props.element[i] = element;
                updateLanguageList()
            }
            return props.element
        })
        setEditElement(null)
    };

    let getConsultEditView = (i, e) => {
        let element = cloneDeep(e)
        let title = (element && element.code && element.level) ? translation(props.lang,computeLabel(element.code._text)) + " - " + translation(props.lang,element.level._text) : "";
        if (e !== editElement)
            return (
                <ConsultCard
                    key={i}
                    index={i}
                    lang={props.lang}
                    computeLabel={(code) => computeLabel(code)}
                    language={e}
                    hasWriteAccess={props.hasWriteAccess}
                    removeElement={() => removeCurrentElement(e)}
                    editElement={() => editCurrentElement(e)}
                    title={title}
                />
            )
        else
            return (
                <EditCard
                    title={translation(props.lang,"Edit")+" : " + title}
                    lang={props.lang}
                    content={<FormLinguisticSkill
                        language={element}
                        lang={props.lang}
                        languageList={languageList}
                        computeLabel={(code) => computeLabel(code)}
                        cancel={() => cancelEditLinguisticSkillHandler()}
                        title={translation(props.lang,"Edit")+" : " + title}
                        buttonTitle={translation(props.lang, "Confirm")}
                        submit={() => submitEditHandler(element)}
                    />}
                />
            )
    }

    const removeCurrentElement = (element) => {
        props.element.map((e, i) => {
            if (e === element) {
                props.element.splice(i, 1);
                setRemovedElements(removedElements.concat(element))
                updateLanguageList()
            }
            return props.element
        })
    }

    let allLanguages = [
        {"code": "EN","label": "English"},
        {"code": "FR","label": "French"},
        {"code": "NL","label": "Dutch"},
        {"code": "IT","label": "Italian"},
        {"code": "RU","label": "Russian"},
        {"code": "PL","label": "Polish"},
        {"code": "ES","label": "Spanish"},
        {"code": "PT","label": "Portuguese"},
        {"code": "EL","label": "Greek"},
        {"code": "AR","label": "Arabic"},
        {"code": "DE","label": "German"}
    ]

    let updateLanguageList = () => {
        let list = []
        allLanguages.map(l => props.element.every (e => l.code !== e.code._text) && list.push (l))
        setLanguageList(list)
    }

    let computeLabel = (code) => {
        return allLanguages.find(l => l.code === code).label
    }

    function editCurrentElement(e) {
        setEditElement(e);
    }

    return (

        <Aux>
            {props.element.map((e, i) => {
                return (
                    <div key={i} className={classes.linguisticSkill}>
                        {getConsultEditView(i, e)}
                    </div>
                )
            })}
            { expanded ? (
                <EditCard
                    lang={props.lang}
                    title={translation(props.lang, "New Linguistic Skill")}
                    content={<FormLinguisticSkill
                        language={ previousLinguisticSkills[previousLinguisticSkills.length - 1] }
                        lang={props.lang}
                        languageList={languageList}
                        computeLabel={(code) => computeLabel(code)}
                        cancel={() => cancelEditLinguisticSkillHandler()}
                        title={translation(props.lang, "New Linguistic Skill")}
                        buttonTitle="Add"
                        submit={ submitHandler }
                    />}
                />
            ) : props.hasWriteAccess && <Row className={ classes.SpacingTop }>
                <Col sm="11"/>
                <Col sm="1">
                    <Icon
                        classIcon="fas fa-plus-circle"
                        color="#464775"
                        size="30"
                        label="Add new Linguistic Skill "
                        action={addLinguisticSkillHandler}
                    />
                </Col>
            </Row>}
        </Aux>
    );


};

export default LinguisticSkills;
